import moment from "moment";
import { config } from "../app.config";

export const date = (date: string, format: string = config.format.date) => {
  return moment(date).format(format);
};

export const time = (date: string, format: string = config.format.time) => {
  return moment(date).format(format);
};

export const dateTime = (date: string, format: string = config.format.dateTime) => {
  return moment(date).format(format);
};
